<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h5 v-if="this.rkasType === 'rkas'">Kertas Kerja</h5>
          <h5 v-else-if="this.rkasType === 'rkas-super-admin'">RKAS {{ $route.query.school_name }}</h5>
          <h5 v-else-if="this.rkasType === 'realisasi'">Realisasi</h5>
          <h5 v-else-if="this.rkasType === 'laporan'">Laporan{{ $route.query.school_name ? ' ' + $route.query.school_name : '' }}</h5>
          <div class="d-flex align-items-center" style="gap: 0.5rem">
            <b-button-group class="add-button-group ml-auto">
              <b-btn variant="success" type="button" @click.prevent="doExport"
                ><font-awesome-icon icon="file-excel" /> Ekspor</b-btn
              >
            </b-button-group>
            <b-button-group  v-if="this.rkasType === 'rkas'" class="add-button-group">
              <b-btn variant="primary" to="/rencana/create">Tambah Data</b-btn>
            </b-button-group>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          {{  this.list.school_id }}
          <b-row class="filter-row">
            <b-col cols="6" md="3">
              <form-group-input
                ref="filter-sumber-dana"
                type="enum"
                :options="list.sumber_dana"
                v-model="filter.sumber_dana"
                placeholder=""
                :need-label="true"
                label="Sumber Dana"
                id="filter-sumber-dana"
              />
            </b-col>
            <b-col cols="6" md="3">
              <form-group-input
                ref="filter-date_period"
                type="enum"
                :multiple="true"
                :options="list.date_periods"
                v-model="filter.date_period"
                placeholder=""
                :need-label="true"
                label="Bulan"
                id="filter-date_period"
              />
            </b-col>
            <b-col cols="6" md="2">
              <form-group-input
                :clearable="false"
                ref="filter-year-period"
                type="enum"
                :options="list.year_periods"
                v-model="filter.year_period"
                placeholder=""
                :need-label="true"
                label="Tahun"
                id="filter-year-period"
              />
            </b-col>
            <b-col cols="6" md="2">
              <label class="form-label">&nbsp;</label><br />
              <b-btn
                type="submit"
                @click.prevent="doFilter"
                class="btn-in-form"
                variant="primary"
              >
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :key="componentKey"
      :needSelect="this.rkasType !== 'laporan'"
      :delete-reason="false"
      :noActions="$store.getters['account/accountData'].role !== 'admin-sekolah' || this.rkasType === 'laporan'"
      :can-delete="true"
      :can-edit="false"
      :can-show="true"
      :data-url="apiUrl.planning"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
      <template slot="expand_content" slot-scope="defaultSlotScope">
        <div style="margin-top: -12px;">
          <table class="table" style="border-top: 0px;">
            <tr class="expand-row-fs text-center">
              <th width="15%" style="font-weight: 600;">Bulan</th>
              <th width="20%" style="font-weight: 600; text-align: right;">Harga Satuan</th>
              <th width="15%" style="font-weight: 600;">Jenis Satuan</th>
              <th  width="20%" style="font-weight: 600; text-align: right;">Total Harga</th>
              <th  width="15%" style="font-weight: 600;">Volume</th>
              <th  width="15%" style="font-weight: 600;">Frekuensi</th>
              <th  width="10%" style="font-weight: 600;"></th>
              <th  width="3%"></th>
              <th  width="2%"></th>

            </tr>
            <tr v-for="detail in defaultSlotScope.colData.details" :key="detail.id">
              <td class="text-center">
                {{ $moment(detail.bulan_kegiatan).format('MMMM') }}
              </td>
              <td class="text-right">
                Rp{{ $formatPrice(detail.harga_satuan) }}
              </td>
              <td class="text-center">
                {{ detail.jenis_satuan }}
              </td>
              <td class="text-right">
                Rp{{ $formatPrice(detail.total_harga) }}
              </td>
              <td class="text-center">
                {{ detail.volume }}
              </td>
              <td style="border-right-width: 0px !important;">
                {{ detail.frekuensi ? detail.frekuensi : '-' }}
              </td>
              <td colspan="2" style="border-left-width: 0px !important;"></td>
            </tr>
          </table>

          <h5 class="pl-2" v-if="defaultSlotScope.colData.details.filter(detail => { return detail.realisasi_harga_satuan !== null }).length && (defaultSlotScope.colData.status === statusRkas.disetujui || defaultSlotScope.colData.status === statusRkas.posting)">Realisasi</h5>
          <table class="table" v-if="defaultSlotScope.colData.details.filter(detail => { return detail.realisasi_harga_satuan !== null }).length && (defaultSlotScope.colData.status === statusRkas.disetujui || defaultSlotScope.colData.status === statusRkas.posting)" style="border-top: 0px;">
            <tr class="expand-row-fs text-center">
              <th width="15%" style="font-weight: 600;">Bulan</th>
              <th width="10%" style="font-weight: 600; text-align: right;">Harga Satuan</th>
              <th width="15%" style="font-weight: 600;">Jenis Satuan</th>
              <th  width="10%" style="font-weight: 600; text-align: right;">Total Harga</th>
              <th  width="15%" style="font-weight: 600;">Volume</th>
              <th  width="15%" style="font-weight: 600;">Frekuensi</th>
              <th  width="10%" style="font-weight: 600;"></th>
              <th  width="3%"></th>
              <th  width="2%"></th>
            </tr>
            <tr v-for="detail in defaultSlotScope.colData.details" :key="detail.id">
              <td class="text-center">
                {{ $moment(detail.bulan_kegiatan).format('MMMM') }}
              </td>
              <td class="text-right">
                Rp{{ $formatPrice(detail.realisasi_harga_satuan) }}
              </td>
              <td class="text-center">
                {{ detail.realisasi_jenis_satuan }}
              </td>
              <td class="text-right">
                Rp{{ $formatPrice(detail.realisasi_total_harga) }}
              </td>
              <td class="text-center">
                {{ detail.realisasi_volume }}
              </td>
              <td style="border-right-width: 0px !important;">
                {{ detail.realisasi_frekuensi ? detail.realisasi_frekuensi : '-' }}
              </td>
              <td class="text-center">
                <b-button size="small" v-if="detail.school_file_asset_id" class="mr-2" variant="info" @click.prevent="openFilePreview(detail.school_file_asset_id)">
                  <font-awesome-icon icon="search-plus"></font-awesome-icon>
                </b-button>
              </td>
              <td colspan="2" style="border-left-width: 0px !important;"></td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="content_account_code_id" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
            defaultSlotScope.colData.kode_kegiatan ? defaultSlotScope.colData.kode_kegiatan.code + '-' + defaultSlotScope.colData.kode_kegiatan.name : ''
          }}</span>
        </template>
        <template slot="content_kode_kegiatan_id" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
            defaultSlotScope.colData.account_code ? defaultSlotScope.colData.account_code.code + '-' + defaultSlotScope.colData.account_code.name : ''
          }}</span>
        </template>
        <template slot="content_status" slot-scope="defaultSlotScope">
          <p class="badge text-white m-0" :class="{
            'bg-secondary': defaultSlotScope.colData.status == statusRkas.draft || defaultSlotScope.colData.status == 'verifikasi',
            'bg-danger': defaultSlotScope.colData.status == 'ditolak',
            'bg-success': defaultSlotScope.colData.status == statusRkas.disetujui || defaultSlotScope.colData.status == statusRkas.posting,
            'bg-warning': defaultSlotScope.colData.status == statusRkas.revisi,
            }" style="text-transform: capitalize; font-size: 14px;">{{
            defaultSlotScope.colData.status
          }}</p>
        </template>
        <template slot="content_bulan_kegiatan_terlama" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
            defaultSlotScope.colData.details ? defaultSlotScope.colData.details.map(detail => {
              return $moment(detail.bulan_kegiatan).format('MMMM')
            }).join(' ,') : '-'
          }}</span>
        </template>
        <template slot="actionButtons" slot-scope="defaultSlotScope">
          <div v-if="defaultSlotScope.colData.status === statusRkas.verifikasi">
            <b-badge variant="primary">Data Telah Terkirim</b-badge>
          </div>
          <b-row v-else-if="defaultSlotScope.colData.status === statusRkas.disetujui" class="justify-content-center table-actions">
            <b-button variant="primary" size="sm" :to="getLastPathUrl() + defaultSlotScope.colData.id" class="mb-0 text-center detail mr-1">
              <font-awesome-icon icon="edit"/>
            </b-button>
          </b-row>
          <b-row v-else class="justify-content-center table-actions">
            <!-- <b-button variant="primary" size="sm" :to="getLastPathUrl() + defaultSlotScope.colData.id" class="mb-0 text-center detail mr-1">
              <font-awesome-icon icon="info"/>
            </b-button> -->
            <b-button v-show="defaultSlotScope.colData.status == statusRkas.draft || defaultSlotScope.colData.status == statusRkas.revisi" variant="info" size="sm" :to="getLastPathUrl() + defaultSlotScope.colData.id + '/edit'" class="mb-0 text-center edit">
              <font-awesome-icon icon="pencil-alt"/>
            </b-button>
            <b-button v-show="defaultSlotScope.colData.status == statusRkas.revisi || defaultSlotScope.colData.status == statusRkas.draft" variant="danger" size="sm" type="button" v-on:click.stop.prevent="doDeleteData(defaultSlotScope.colData.id)" class="mb-0 text-center delete ml-1">
              <font-awesome-icon icon="trash"/>
            </b-button>
            <p class="text-center" v-if="defaultSlotScope.colData.status == statusRkas.revisi">Butuh Revisi!</p>
          </b-row>
        </template>
        
    </paginated-table>
    
    <b-row v-if="rkasType === 'realisasi' || this.rkasType === 'laporan'">
      <b-col cols="3">
        <p class="h6">Total Rencana: <strong>Rp{{ $formatPrice(totalRencana) }}</strong></p>
      </b-col>
      <b-col cols="3">
        <p class="h6">Total Digunakan: <strong>Rp{{ $formatPrice(totalDigunakan) }}</strong></p>
      </b-col>
      <b-col cols="3">
        <p class="h6">Total Selisih: <strong>Rp{{ $formatPrice(parseFloat(totalRencana) - parseFloat(totalDigunakan)) }}</strong></p>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="3">
        <p class="h6">Total Anggaran: <strong>Rp{{ $formatPrice(totalAnggaran) }}</strong></p>
      </b-col>
      <!-- <b-col cols="3">
        <p class="h6">Total Digunakan: <strong>Rp{{ $formatPrice(totalDigunakan) }}</strong></p>
      </b-col> -->
    </b-row>
  </b-card>
</template>

<script>
import { objectToOptions, statusRkas } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import Planning from "@/models/Planning.js";

const planningModel = new Planning();

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      componentKey: 0,
      totalPromiseAreaCount: 0,
      apiUrl: {
        planning: planningModel.endpoint,
      },
      rkasType: 'rencana',
      current_year: new Date().getFullYear(),
      totalRencana: 0,
      totalDigunakan: 0,
      statusRkas: statusRkas(),
      columns: [
        {
          prop: "kode_kegiatan_id",
          label: "Kegiatan",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "account_code_id",
          label: "Kode Rekening",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "uraian_kegiatan",
          label: "Uraian Kegiatan",
          sortable: true,
          resizable: true,
          minWidth: 300,
        },
        // {
        //   prop: "volume",
        //   label: "Volume",
        //   sortable: true,
        //   resizable: true,
        //   minWidth: 200,
        // },
        // {
        //   prop: "frekuensi",
        //   label: "Frekuensi",
        //   sortable: true,
        //   resizable: true,
        //   minWidth: 200,
        // },
        // {
        //   prop: "jenis_satuan",
        //   label: "Satuan",
        //   sortable: true,
        //   resizable: true,
        //   minWidth: 200,
        // },
        // {
        //   prop: "harga_satuan",
        //   label: "Harga Satuan",
        //   sortable: true,
        //   resizable: true,
        //   minWidth: 200,
        // },
        {
          prop: "bulan_kegiatan_terlama",
          label: "Bulan",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "total_harga_keseluruhan",
          label: "Rencana",
          sortable: true,
          align: 'right',
          resizable: true,
          minWidth: 120,
          needCurrency: true,
        },
        {
          prop: "status",
          label: "Status",
          align: 'center',
          sortable: true,
          resizable: true,
          minWidth: 100,
        },
      ],
      cloneColumns: [],
      list: {
        date_periods: objectToOptions({
          '01-01': 'Januari',
          '02-01': 'Februari',
          '03-01': 'Maret',
          '04-01': 'April',
          '05-01': 'Mei',
          '06-01': 'Juni',
          '07-01': 'Juli',
          '08-01': 'Agustus',
          '09-01': 'September',
          '10-01': 'Oktober',
          '11-01': 'November',
          '12-01': 'Desember',
        }),
        year_periods: [],
        sumber_dana: [],
        budgets: []
      },
      filter: {
        type: 'rkas',
        date_period: typeof this.$route.query.date_period !== 'undefined' ? this.$route.query.date_period : [],
        year_period: typeof this.$route.query.year_period !== 'undefined' ? this.$route.query.year_period : new Date().getFullYear(),
        sumber_dana: typeof this.$route.query.sumber_dana !== 'undefined' ? this.$route.query.sumber_dana : null,
        school_id: typeof this.$route.query.school_id !== 'undefined' ? this.$route.query.school_id : null,
        with_account_code: 1,
        with_kode_kegiatan: 1,
        with_detail: 1,
      },
      dataParams: [
        "school_name",
        "school_id",
        "with_school",
        "with_kode_kegiatan",
        "with_detail",
        "with_account_code",
        "type",
        "date_period",
        "year_period",
        "sumber_dana",
      ],
    };
  },
  computed: {
    totalAnggaran () {
      // console.log(this.list.budgets)
      if (!this.list.budgets || this.list.budgets.length === 0) {
        return 0;
      }
      if (!this.filter.sumber_dana) {
        return this.list.budgets.total
      } else {
        return this.list.budgets.total_details[this.filter.sumber_dana]
      }
    }, 
    // totalDigunakan () {
    //   // console.log(this.list.budgets)
    //   if (!this.list.budgets || this.list.budgets.length === 0) {
    //     return 0;
    //   }
    //   if (!this.filter.sumber_dana) {
    //     return this.list.budgets.used
    //   } else {
    //     return this.list.budgets.used_details[this.filter.sumber_dana]
    //   }
    //   return 0;
    // }
  },
  beforeMount() {
    this.cloneColumns = [...this.columns ]
    this.setRkasType()
    // this.initRouterParams()
  },
  async mounted() {
    this.getYearPeriod()
    this.getSchoolBudget()
    this.getSumberDana()

    this.filter.year_period = this.current_year

    this.getSummary()
  },
  watch: {
    '$route.name': function () {
      this.setRkasType()
      // this.initRouterParams()
      this.clearForm()
    }, 
    'filter.school_id': function () {
      // this.getSchoolBudget()
    },
    'filter.year_period': function () {
      // this.list.budgets = []
      // this.getSchoolBudget()
    }
  },
  methods: {
    openFilePreview (id) {
      window.open('/file-preview/' + id, '_blank', 'toolbar=0,location=0,menubar=0')
    },
    async getSchoolBudget () {
      if (this.list.budgets.length === 0) {
        try {
          if (this.filter.school_id) {
            const budget = await this.$http.post(process.env.VUE_APP_API_URL + "schools/budget-list", {
              ids: [
                this.filter.school_id
              ],
              year_budget: new Date().getFullYear()
            })
            this.list.budgets = budget.data[0]

          } else if (this.$store.getters['account/accountData'].role === 'admin-sekolah') {
            const budget = await this.$http.get(process.env.VUE_APP_API_URL + "me/budgets")
            this.list.budgets = budget.data
          }
        } catch (e) {
          console.error(e)
        }
      }
    },
    setRkasType () {
      if (this.$route.name == 'Rencana') {
        if (this.$store.getters['account/accountData'].role === 'admin-sekolah') {
          this.rkasType = 'rkas'
        } else {
          this.rkasType = 'rkas-super-admin'
        }
      } else if (this.$route.name == 'Realisasi') {
        this.rkasType = 'realisasi'
      } else if (this.$route.name == 'Laporan Realisasi') {
        this.rkasType = 'laporan'
      }
      if (this.rkasType === 'realisasi' || this.rkasType === 'laporan') {
        this.columns = []
        Object.keys(this.cloneColumns).forEach(key => {
          this.columns.push(this.cloneColumns[key])
          if (this.cloneColumns[key].prop === 'total_harga_keseluruhan') {
            this.columns.push({
              prop: "realisasi_total_harga_keseluruhan",
              label: "Realisasi",
              sortable: true,
              align: 'right',
              resizable: true,
              minWidth: 120,
              needCurrency: true,
            })
          }
        })
      } else {
        this.columns = this.cloneColumns
      }
      this.filter.type = this.rkasType
      // if (this.$refs.dataTable) {
      //   // this.componentKey++
      //   this.$refs.dataTable.reRender()
      // }
    },
    // initRouterParams() {
    //   this.$router
    //     .push({
    //       query: {
    //         ...this.$route.query,
    //         ...{
    //           // school_id: this.$store.getters["account/accountData"].school_id,
    //           with_school: 1,
    //           with_account_code: 1,
    //           with_kode_kegiatan: 1,
    //           with_detail: 1,
    //         },
    //       },
    //     })
    //     .catch((err) => {});
    // },
    clearForm() {
      this.$nextTick(() => {
        this.filter.sumber_dana = null
        this.filter.date_period = []
        this.filter.year_period = this.current_year
        // this.filter = {
        //   sumber_dana: null,
        //   type: this.rkasType,
        //   date_period: [],
        //   year_period: this.current_year,
        // };
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    async getSumberDana() {
      return new Promise((resolve) => {
        this.$http.get("/json/sumberDana.json").then((resp) => {
          this.list.sumber_dana = objectToOptions(resp.data.data);
          return resolve();
        });
      })
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
      this.getSummary()
    },
    doExport() {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const filterArray = [];
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push("csv=1");

      this.$http
        .get(planningModel.getEndpoint() + "?" + filterArray.join("&"))
        .then((response) => {
          const a = document.createElement("a");

          const blob = new Blob([response.data], { type: "octet/stream" });
          a.href = window.URL.createObjectURL(blob);

          a.download = "data_admin.csv";
          a.click();
          this.isLoading = false;
        })
        .catch((error) => {
          this.$store.dispatch("notification/error", error);
          this.isLoading = false;
        });
    },
    async getSummary() {
      const filterArray = [];
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push("summary=1");

      try {
        let response = await this.$http.get(planningModel.getEndpoint() + "?" + filterArray.join("&"))
        this.totalRencana = response.data.total_rencana
        this.totalDigunakan = response.data.total_digunakan
      } catch (e) {
        console.error(e)
      }
    },
    getYearPeriod() {
      const year_start = 2023
      const year = this.current_year

      const years = {};
      for (let i = year_start; i <= year; i++) {
        years[i] = i
      }

      this.list.year_periods = objectToOptions(years)
    },
    getLastPathUrl() {
      return this.$refs.dataTable.getLastPathUrl()
    },
    doDeleteData(id) {
      this.$refs.dataTable.doDeleteData(id)
    }
  },
};
</script>

<style>
  .expand-row-fs {
    font-size: 13px;
  }
</style>